import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    name: "",
    registrationNumber: "",
    safeNumber: "",
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    zip: "",
    country: "",
};

const companyInfoReducer = createSlice({
    name: "companyInformation",
    initialState,
    reducers: {
        updateCompanyInfo(state, {payload}) {
            state.name = payload.name || '';
            state.registrationNumber = payload.registrationNumber || '';
            state.safeNumber =  payload.safeNumber || '';
            state.streetAddress1 = payload.streetAddress1 || '';
            state.streetAddress2 = payload.streetAddress2 || '';
            state.city = payload.city || '';
            state.zip = payload.zip || '';
            state.country = payload.country || '';
        }
    }
});

export const selectCompanyInfo = (state) => state.companyInformation;

export const { updateCompanyInfo } = companyInfoReducer.actions
export default companyInfoReducer.reducer
